export const getResidentsListItems = /* GraphQL */ `
  query GetResidentsListItems(
    $pagination: PaginationInput
    $sorting: GetResidentsSortByInput
    $filter: GetResidentsFilterStatusInput
  ) {
    getResidents(pagination: $pagination, sorting: $sorting, filter: $filter) {
      items {
        id
        firstName
        lastName
        siteAddress {
          addressLine1
          city
          lotUnit
          state
          zipCode
        }
        insuranceAdoption {
          status
        }
        policyType
        community {
          name
          portfolio {
            name
          }
        }
        createdAt
        updatedAt
        residentId
      }
      pagination {
        from
        size
        total
      }
    }
  }
`;

export const searchResidentsQuery = /* GraphQL */ `
  query SearchResidentsListQuery(
    $pagination: PaginationInput
    $query: String!
  ) {
    searchResidents(pagination: $pagination, query: $query) {
      items {
        id
        firstName
        lastName
        siteAddress {
          addressLine1
          city
          lotUnit
          state
          zipCode
        }
        insuranceAdoption {
          status
        }
        policyType
        community {
          name
          portfolio {
            name
          }
        }
        createdAt
        updatedAt
        residentId
      }
      pagination {
        from
        size
        total
      }
    }
  }
`;

export const getResidentBasicData = /* GraphQL */ `
  query GetResidentBasicData {
    getResident {
      id
      firstName
      lastName
      siteAddress {
        addressLine1
        city
        lotUnit
        state
        zipCode
      }
      insuranceAdoption {
        status
      }
      community {
        name
      }
      createdAt
      updatedAt
      phoneNumber
      email
      residentId
    }
  }
`;

export const getManufacturers = /* GraphQL */ `
  query GetManufacturers($search: String!) {
    getParameters(type: Manufacturer, search: $search)
  }
`;
